import { Box } from '@mui/material';

const CustomChip = ({ label, color = 'default', size = 'medium' }) => {
  const colorMap = {
    default: '#e0e0e0',
    primary: '#1976d2',
    secondary: '#9c27b0',
    warning: '#ff9800',
    error: '#f44336',
    success: '#4caf50',
  };

  const sizeMap = {
    small: { height: '24px', fontSize: '0.8125rem', padding: '0 8px' },
    medium: { height: '32px', fontSize: '0.875rem', padding: '0 12px' },
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `${colorMap[color]} !important`,
        color: '#FFF',
        fontWeight: 600,
        borderRadius: '16px',
        border: `1px solid ${colorMap[color]}`,
        boxShadow: 'none',
        textShadow: 'none',
        opacity: '1 !important',
        ...sizeMap[size],
      }}
    >
      {label}
    </Box>
  );
};

export default CustomChip;